import styled from "styled-components";

export enum TextVariant {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  subtitle1,
  subtitle2,
  body1,
  body2,
  caption,
}

export const getFontStylesByVariant = (
  variant?: TextVariant
): { fontSize: string; fontWeight: string } => {
  switch (variant) {
    case TextVariant.caption:
      return { fontSize: "13px", fontWeight: "400" };
    case TextVariant.subtitle1:
      return { fontSize: "16px", fontWeight: "500" };
    case TextVariant.subtitle2:
      return { fontSize: "15px", fontWeight: "500" };
    case TextVariant.body1:
      return { fontSize: "15px", fontWeight: "400" };
    case TextVariant.body2:
      return { fontSize: "14px", fontWeight: "400" };
    case TextVariant.h1:
      return { fontSize: "36px", fontWeight: "545" };
    case TextVariant.h2:
      return { fontSize: "28px", fontWeight: "545" };
    case TextVariant.h3:
      return { fontSize: "24px", fontWeight: "500" };
    case TextVariant.h4:
      return { fontSize: "20px", fontWeight: "500" };
    case TextVariant.h5:
      return { fontSize: "18px", fontWeight: "450" };
    case TextVariant.h6:
      return { fontSize: "14px", fontWeight: "450" };
    default:
      return { fontSize: "13px", fontWeight: "500" };
  }
};

export const TypographyNew = styled.p<{
  variant?: TextVariant;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  noWrap?: boolean;
  italic?: boolean;
  inline?: boolean;
  color?: string;
  align?: string;
  lineHeight?: string;
  overflow?: string;
}>`
  font-size: ${(props) => getFontStylesByVariant(props.variant).fontSize};
  font-family: Roboto;
  ${(props) => (props.italic ? `font-style:italic` : "")};
  ${(props) => (props.inline ? `display:inline` : "")};
  font-weight: ${(props) => getFontStylesByVariant(props.variant).fontWeight};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "0px"};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0px")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0px")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0px")};
  white-space: ${(props) => (props.noWrap ? "nowrap" : "normal")};
  text-overflow: ellipsis;
  overflow: ${(props) => (props.overflow ? props.overflow : "hidden")};
  color: ${(props) => (props.color ? props.color : "inherit")};
  text-align: ${(props) => props.align};
  line-height: ${({ lineHeight }) => lineHeight || "1.33"};
`;
